module.exports = __webpack_public_path__ + "img/ARM_Logo.48ab05fe.png";